<template>
    <div class="vue-onboarding__header">
        <div class="vue-onboarding__header__content flex justify-between text-lg">
            <span class="font-medium">{{ $t(title) }}</span>
            <span class="font-medium">{{ stepText }}</span>
        </div>        
    </div>
</template>

<script>
export default {
    name: "vue-onboarding-header-per-page",

    components: {
       
    },

    props: {
        title: String,
        stepText: String,       

        // The props confirm closeable
        confirmable: {
            type: Boolean,
            default: false,
        },

        confirmText: {
            type: String,
            default: "",
        },

        confirmCallback: {
            type: Function,
            default: () => {}
        }        
    },

    methods: {        
    },
};
</script>

<style lang="scss">
.vue-onboarding__header {
    .vue-onboarding__header__content {
        border-radius: 6px 6px 0 0;
        background:  #DA2D8A;
        padding: 10.5px 16px;
        color: #FFFFFF;
        border: 1px solid #F3F2F7       
    }
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingHeaderPerPage.vue